import { fromJS } from 'immutable';
import {
  ATTACK,
  ATTACK_END,
} from './constants';

/**
 * `picks`, for moves that ask for one: `energyAttachmentId`, the Defending Pokémon's energy card to discard
 * (Whirlpool), `benchPosition`, the opponent's benched Pokémon to switch in (Lure), or `defendingMoveId`, the
 * Defending Pokémon's attack to block (Amnesia).
 */
export const attack = (moveId, picks = {}) => ({
  type: ATTACK,
  payload: fromJS({ moveId, picks }),
});

export const attackEnd = () => ({
  type: ATTACK_END,
});